import React from 'react';
import { withRouter } from 'react-router-dom';

import { Checkbox, Field, Form, Loader } from '@smartplatform/ui';
import { useGetRecord } from 'root/admin/components/hooks';

import { Editor, Title } from 'root/admin/components';
import { Thumbnail } from '..';
import store from 'client/store';

// TagsEdit

const TagsEdit = ({ model, match, rootPath }) => {
	const [generalType, setGeneralType] = React.useState(false);
	const { id } = match.params;
	const record = useGetRecord({ model: 'Tag', id, tabName: 'tags' });
	const onGeneralTypeChange = () => setGeneralType(!generalType);
	React.useEffect(() => setGeneralType(record?.type === 'all' ? true : false), [record]);

	if (!record) {
		return <Loader />;
	}

	const beforeSave = () => {
		record.type = generalType ? 'all' : model;
	};

	return (
		<div>
			<Title record={record} name='Категория' />
			<Form beforeSave={beforeSave} record={record} rootPath={rootPath} className='tag-edit'>
				<Field property='name' label='Название категории' />
				<Field property='weight' label='Вес категории' />
				<Field property='description' label='Описание категории'>
					<Editor height={600} mediaModel={store.model.Image}/>
				</Field>
				<Field property='path' label='Путь категории' />
				<Checkbox className='checkbox' value={generalType} onChange={onGeneralTypeChange}
						  label='Общая для всех материалов категория' />

				<Thumbnail record={record} label='Изображение' field='image' />

			</Form>
		</div>
	);
};

export default withRouter(TagsEdit);
// export default TagsEdit;
